const CAMPAIGN_START = process.env.VUE_APP_MIGRATION_START_DATE || "2026-08-31";
const MODAL_SHOWN_KEY = "xm_migration_modal_last_shown";

export function getMigrationPhase(now = Date.now()) {
  const start = new Date(`${CAMPAIGN_START}T00:00:00+08:00`).getTime();
  const elapsedDays = Math.max(0, Math.floor((now - start) / 86400000));

  if (elapsedDays >= 28) {
    return { phase: "read_only", elapsedDays, reminderInterval: 86400000 };
  }
  if (elapsedDays >= 14) {
    return { phase: "strong", elapsedDays, reminderInterval: 86400000 };
  }
  return { phase: "soft", elapsedDays, reminderInterval: 7 * 86400000 };
}

export function shouldShowMigrationModal({ loggedIn, migrated, campaign = getMigrationPhase(), now = Date.now(), storage = localStorage }) {
  if (!loggedIn || migrated) return false;
  const lastShown = Number(storage.getItem(MODAL_SHOWN_KEY)) || 0;
  return now - lastShown >= campaign.reminderInterval;
}

export function markMigrationModalShown(now = Date.now(), storage = localStorage) {
  storage.setItem(MODAL_SHOWN_KEY, String(now));
}

export function trackMigrationEvent(eventName, params = {}) {
  const detail = { event: eventName, ...params, timestamp: Date.now() };
  if (Array.isArray(window._hmt)) {
    window._hmt.push(["_trackEvent", "migration", eventName, JSON.stringify(params)]);
  }
  window.dispatchEvent(new CustomEvent("xm:migration-track", { detail }));

  const trackUrl = process.env.VUE_APP_MIGRATION_TRACK_URL;
  if (!trackUrl) return;
  const body = JSON.stringify(detail);
  if (navigator.sendBeacon) {
    navigator.sendBeacon(trackUrl, new Blob([body], { type: "application/json" }));
    return;
  }
  fetch(trackUrl, { method: "POST", body, headers: { "Content-Type": "application/json" }, keepalive: true }).catch(() => {});
}
